import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';

export function getQRCode(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('getQRCode')) {
        return;
    }

    return function(title: string): Promise<string> {
        return messageBus
            .sendRequest<{ qrcode: string; error?: string }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'getQRCode', args: [title] }).map(JSON.stringify)
            )
            .then(response => {
                if (response.value.error) {
                    throw new Error(response.value.error);
                }
                return response.value.qrcode;
            });
    };
}
